import { render, staticRenderFns } from "./CentrosDeCosto.vue?vue&type=template&id=212b9bec&"
import script from "./CentrosDeCosto.vue?vue&type=script&lang=js&"
export * from "./CentrosDeCosto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports